import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Paper, SxProps, Theme } from '@mui/material';

import { canStartTrial, canUpgradeAccount } from '../../selectors/users';
import { upgradePlanColorGradient } from './colors';

interface Props {
  readonly active?: boolean;

  readonly description?: string;

  readonly trialDescription?: string;

  readonly briefDescription?: string;

  readonly onUpgradeClick: () => void;

  readonly sx?: SxProps<Theme>;
}

export function UpgradeNotification({
  active,
  description,
  trialDescription,
  briefDescription,
  onUpgradeClick,
  sx,
}: Props) {
  const canUpgrade = useSelector(canUpgradeAccount);
  const trialAvailable = useSelector(canStartTrial);
  if (active === false || !canUpgrade) return null;

  const message = trialAvailable
    ? (trialDescription ??
      (briefDescription ? `Start your free trial to access ${briefDescription}.` : 'Start your free trial to access.'))
    : (description ??
      (briefDescription ? `Upgrade your account to access ${briefDescription}.` : 'Upgrade your account to access.'));

  return (
    <Paper
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          padding: 1,
          background: upgradePlanColorGradient,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ mr: 1 }}>{message}</Box>

      <Button size="small" sx={{ marginLeft: 'auto' }} variant="outlined" onClick={onUpgradeClick}>
        {trialAvailable ? 'Start Free Trial' : 'View Plans'}
      </Button>
    </Paper>
  );
}
